import { useQuery } from "@tanstack/react-query";

import { getMyPermissions } from "../services/me";
import { getCompanyFeatureFlagAuditLog, getCompanyMatrix } from "../services/company";
import {
	getFeatureFlag,
	getFeatureFlags,
	getCompanyFeatureFlags,
	getFeatureFlagMatrix,
} from "../services/featureFlags";
import { getSeedConfigurations, getSeedConfigurationById } from "../services/seeder";

export const useFeatureFlags = (env, options) => {
	return useQuery({
		queryKey: ["feature-flags", env],
		queryFn: () => getFeatureFlags(env),
		...options,
	});
};

export const useFeatureFlag = (env, slug, options) => {
	return useQuery({
		queryKey: ["feature-flag", env, slug],
		queryFn: () => getFeatureFlag(env, slug),
		...options,
	});
};

export const useCompanyFeatureFlags = (env, companyId, options) => {
	return useQuery({
		queryKey: ["company-feature-flags", env, companyId],
		queryFn: () => getCompanyFeatureFlags(env, companyId),
		...options,
	});
};

export const useCompanyFeatureFlag = (env, companyId, flagId, options) => {
	const query = useQuery({
		queryKey: ["company-feature-flags", env, companyId],
		queryFn: () => getCompanyFeatureFlags(env, companyId),
		...options,
	});

	const flag = query.data?.featureFlags.find((flag) => flag._id === flagId);

	return {
		...query,
		data: flag,
	};
};

export const useCompanyFeatureFlagAuditLog = (env, companyId, flagId, options) => {
	return useQuery({
		queryKey: ["company-feature-flag-audit-log", env, companyId, flagId],
		queryFn: () =>
			getCompanyFeatureFlagAuditLog({
				environment: env,
				slug: flagId,
				companyId: companyId,
			}),
		...options,
	});
};

export const useFeatureFlagMatrix = (env, options) => {
	return useQuery({
		queryKey: ["feature-flag-matrix", env],
		queryFn: () => getFeatureFlagMatrix(env),
		...options,
	});
};

export const useCompanyMatrix = (env, options) => {
	return useQuery({
		queryKey: ["company-matrix", env],
		queryFn: () => getCompanyMatrix(env),
		...options,
	});
};

export const useMyPermissions = (options) => {
	return useQuery({
		queryKey: ["my-permissions"],
		queryFn: () => getMyPermissions(),
		...options,
	});
};

export const useSeedConfigurations = (options) => {
	return useQuery({
		queryKey: ["seed-configurations"],
		queryFn: () => getSeedConfigurations(),
		...options,
	});
};

export const useSeedConfiguration = (configurationId, options) => {
	return useQuery({
		queryKey: ["seed-configuration", configurationId],
		queryFn: () => getSeedConfigurationById(configurationId),
		enabled: !!configurationId,
		...options,
	});
};
